import React, { useEffect } from 'react';
import { editor } from '@/instance';
import { useMattingPluginHelper } from '../use-matting-plugin-helper';

export const AI_MATTING_IMAGE = 'kt';

const AiMattingExtension = () => {
    const mattingPluginHelper = useMattingPluginHelper();

    useEffect(() => {
        const layer = editor.active.getPick();
        mattingPluginHelper.show(!layer);
    }, []);

    return <></>;
};

export default React.memo(AiMattingExtension);
